import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

// Azure AD configuration for TC Config Admin Portal
// Restricted to tc-config.com and technologyconsulting.llc domains
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '7ccee278-c2a9-427a-934d-ef556d8fcc40',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_ADMIN_TENANT_ID || 'a81e93a5-26ae-460f-ac1e-d4bc4a8d281a'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Scopes for admin portal access
export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
  // Restrict to specific domains
  loginHint: '',
  domainHint: '', // Can be set to 'tc-config.com' or 'technologyconsulting.llc'
};

// API request configuration 
export const apiRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE || 'api://7ccee278-c2a9-427a-934d-ef556d8fcc40/user_impersonation'],
};

// Allowed email domains for admin access
export const ALLOWED_ADMIN_DOMAINS = [
  'tc-config.com',
  'technologyconsulting.llc'
];

// Tenant ID for validation
export const ADMIN_TENANT_ID = 'a81e93a5-26ae-460f-ac1e-d4bc4a8d281a';

// Function to validate if user is from allowed domain
export function isValidAdminUser(email: string, tenantId: string): boolean {
  if (tenantId !== ADMIN_TENANT_ID) {
    return false;
  }
  
  const domain = email.split('@')[1]?.toLowerCase();
  return ALLOWED_ADMIN_DOMAINS.includes(domain);
}

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
